import TestResultStatusComp from './TestResultStatus';
import TableRowActionMenu from '../BaseComponents/TableRowActionMenu';
import './Alerts.scss';
import {
  changeDeleteTestResultModalVisibility,
  changeShowAlertTestResultModalVisibility,
  setAlertsListByAppointment,
  setSelectedTestResultId,
  setSelectedTestResultMemberDOB,
  setSelectedTestResultMemberId,
  setSelectedTestResultMemberName
} from '../../store/alertsSlice';
import { useDispatch, useSelector } from 'react-redux';
import {
  BiomarkerResultType,
  UnprocessedBiomarkerElement
} from '../../types/apiGeneratedTypes';
import { formatInTimeZone } from 'date-fns-tz';
import { RootState } from '../../store/store';
import { getBiomarkersResultsByAppointment } from '../../api/biomarkers';

type AlertRowProps = {
  alertData: UnprocessedBiomarkerElement;
};

const AlertRow = ({ alertData }: AlertRowProps) => {
  const dispatch = useDispatch();
  const { biomarkersList } = useSelector((state: RootState) => state.app);
  const onOptionClick = async (id: number, action: any) => {
    if (action === 'delete') {
      dispatch(setSelectedTestResultId(alertData.appointment_id));
      const response = await getBiomarkersResultsByAppointment(
        id!,
        BiomarkerResultType.UNPROCESSED
      );
      dispatch(setAlertsListByAppointment(response.biomarkers));
      dispatch(changeDeleteTestResultModalVisibility(true));
    }
  };

  const onRowClick = () => {
    dispatch(setSelectedTestResultId(alertData.appointment_id));
    dispatch(setSelectedTestResultMemberName(alertData.member_name));
    setSelectedTestResultMemberDOB(alertData.member_dob);
    dispatch(setSelectedTestResultMemberId(alertData.member_id!));
    dispatch(changeShowAlertTestResultModalVisibility(true));
  };

  return (
    <div className='table-row alerts-table-row' onClick={onRowClick}>
      <div className='alert-member-name'>{alertData.member_name}</div>
      <div className='appointment-date'>
        {formatInTimeZone(
          new Date(alertData.appointment_date),
          'Europe/London',
          'dd/MM/yyyy'
        )}
      </div>
      <div className='biomarkers-count'>
        {alertData.results_count} / {biomarkersList.length}
      </div>
      <div className='status-container'>
        <TestResultStatusComp status={alertData.status} />
      </div>
      <div className='actions'>
        <TableRowActionMenu
          options={[
            // { key: 'edit', value: 'Edit' },
            { key: 'delete', value: 'Delete result' }
          ]}
          id={alertData.appointment_id}
          onActionMenuClick={onOptionClick}
        />
      </div>
    </div>
  );
};

export default AlertRow;
